module.exports = __webpack_public_path__ + "static/media/shadee.306b0f8d.jpg";